import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DatePicker } from '@beeline/design-system-react/extracted-styles';

import {
  getDesksState,
  getDesksDate,
  getDesksTimeBounds,
} from 'src/store/desks/selectors';
import { desksActions } from 'src/store/desks/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const DeskBookingSettings: FC = () => {
  const dispatch = useAppDispatch();
  const { backgroundData } = useSelector(getDesksState);
  const date = useSelector(getDesksDate);

  const setDate = useCallback(
    (value: string | undefined) => {
      dispatch(desksActions.setDate(value));
    },
    [dispatch],
  );

  const { min, max, error } = useSelector(getDesksTimeBounds);

  return (
    <DatePicker
      label='Дата'
      minDate={min}
      maxDate={max}
      onChange={setDate}
      value={date}
      disabled={!backgroundData}
      error={!!error}
      helperText={error}
      dataTestId='deskBookingDate'
      fullWidth
    />
  );
};
